import { makeStyles } from '@material-ui/core/styles';

const useGlobalStyles = makeStyles((theme) => ({
	'@global': {
		'.content': {
			padding: '25px 3vw',
			[theme.breakpoints.up('md')]: {
				padding: '50px 0',
			},
			maxWidth: '700px',
			margin: '0 auto',
			height: '100%',
		},
		'.contentSmallPdTop': {
			padding: '10px 3vw',
			[theme.breakpoints.up('md')]: {
				padding: '50px 0',
			},
			maxWidth: '700px',
			margin: '0 auto',
			height: '100%',
		},
		'.contentCompanyInfo': {
			padding: '20px 3vw',
			[theme.breakpoints.up('lg')]: {
				padding: '50px 0',
			},
			maxWidth: '700px',
			margin: '0 auto',
			height: '100%',
		},
		'.contentList': {
			padding: '0 3vw',
			[theme.breakpoints.up('md')]: {
				padding: '20px 0',
			},
			margin: '0 auto',
			height: '100%',
		},
	},
}));

export default useGlobalStyles;
